module.exports = __webpack_public_path__ + "static/media/d2.8d9c7f1b.png";